<app-dashboard-container
	class="dashboard-doorstroom"
	[factTable]="factTable"
	(doExport)="this.doExport(filterExpressions(),permanentFilters(),$event)"
>
	<app-filter-panel
		[defaultFilters]="actueelFilters"
		[allFilters]="allFilters()"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/doorstroom"
		[permanentFilterExpressions]="permanentFilters()"
	></app-filter-panel>
	<app-filter-bar [dataRootSelection]="dataRootSelection()"></app-filter-bar>
	<section class="dashboard">
		<app-dashboard-header>
			<div class="cl-header-subtitle">{{ getSchooljarenCaption() }}</div>
			<app-toggle-buttons [options]="varianten" [value]="variant()" (valueChange)="qp.dispatch('variant', $event)"></app-toggle-buttons>
			<app-schooljaar-indicator-over></app-schooljaar-indicator-over>
			<app-onderwijsresultaten-uitsluiten-filter></app-onderwijsresultaten-uitsluiten-filter>
			<app-checkbox
				label="Toon vestigingscode-overgang"
				[value]="toonBrinOvergang()"
				(valueChange)="qp.dispatch('brin-overgang', $event)"
			></app-checkbox>
			<app-legenda class="cl-header-utility" [attribute]="['ds_nm_idu']" [includeNull]="true" [exclude]="legendaExcludes"></app-legenda>
		</app-dashboard-header>
		<app-barchart-table
			[tableGroups]="table"
			[groups]="groups()"
			[filters]="filterExpressions()"
			[permanentFilters]="permanentFilters()"
			[subgroups]="toonBrinOvergang() ? doorstroomLevelsMetOvergang : doorstroomLevelsZonderOvergang"
			[config]="this"
		></app-barchart-table>
	</section>
</app-dashboard-container>
